import React, {useState} from 'react';
import { useFirestore } from 'reactfire';
import { AutoComplete } from 'antd';


const SearchDisease = (props) => {

    const [value, setValue] = useState('');
    const [options, setOptions] = useState([]);
    const firestore = useFirestore();

    const query = firestore.collection("Diagnosis");

    const onChange = (data) => {
        setValue(data);
    };

    const onSelect = (data) => {
        props.onSelectProp(data)
        setValue('');
    };

    const onSearch = (searchText) => {
        console.log(searchText);
        let records = [];
            query.orderBy('disease_name')
            .startAt(searchText)
            .endAt(searchText+`\uf8ff`).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                records.push({value: doc.data().disease_name, key: doc.id});
            });
            setOptions(records);
            });
      
        
    };

    // const onSearch = (searchText) => {
    //     let records = [];
    //     query
    //     .where('disease_name', '<=',searchText).get().then((querySnapshot) => {
    //         console.log(querySnapshot);

    //       querySnapshot.forEach((doc) => {
    //         console.log(doc);

    //           records.push({value: doc.data().disease_name});
    //       });
    //       setOptions(records);
    //     });
    // };

    return (
        <AutoComplete
            value={value}
            options={options}
            style={{
            width: 500,
            margin: '0 auto',
            display: 'block',
            }}
            onSelect={onSelect}
            onSearch={onSearch}
            onChange={onChange}
            placeholder="Search Diseases"
        />
    );
}

export default SearchDisease;
